<template>
  <div class="time-text-container">
    <div id="svg-shake" class="svg-wrapper">
      <div class="time-text-line-1">
        <p class="time-text" id="y1">1</p>
        <p class="time-text" id="y2">9</p>
        <p class="time-text" id="y3">9</p>
        <p class="time-text" id="y4">9</p>
        <p class="time-text" id="y5">.</p>
        <p class="time-text" id="y6">0</p>
        <p class="time-text" id="y7">9</p>
        <p class="time-text" id="y8">.</p>
        <p class="time-text" id="y9">2</p>
        <p class="time-text" id="y10">1</p>
      </div>
      <div class="time-text-line-2">
        <!-- <h1 class="time-text" id="c1">0</h1> -->
        <h1 class="time-text" id="c2">1</h1>
        <h1 class="time-text" id="c3">:</h1>
        <h1 class="time-text" id="c4">4</h1>
        <h1 class="time-text" id="c5">7</h1>
      </div>

    </div>
  </div>
</template>

<script>
import { TweenMax, Power2, TimelineLite } from "gsap/TweenMax";

export default {
  name: "TimeText",
  props: {
    coverShakeFlag: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    coverShakeFlag: {
      handler(flag) {
        if (flag) {
          this.textShake();
        }
      },
      deep: true
    }
  },
  methods: {
    textShake() {
      var botDomArr, topDomArr, hardshake;

      botDomArr = [];
      topDomArr = [];
      hardshake = [];

      // get elements
      for (let i = 0; i < 8; i++) {
        var topel = document.getElementById("c" + i);
        botDomArr.push(topel);
      }

      for (let n = 0; n < 11; n++) {
        var bottomel = document.getElementById("y" + n);
        topDomArr.push(bottomel);
      }

      botDomArr.splice(0, 1); // 刪掉 arr 裡的 null
      topDomArr.splice(0, 1);

      //Get shake random
      function getRandom(min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
      }
      for (let n = 0; n < 11; n++) {
        hardshake.push(getRandom(5, 18));
      } // 強震動亂數 比較強的

      // 亂數震動動態
      var el = [botDomArr, topDomArr];

      function bigerShake() {
        for (let n = 0; n < 11; n++) {
          TweenMax.fromTo(
            [topDomArr[n], botDomArr[n]],
            0.05,
            { y: hardshake[n], x: 0 },
            { y: -1, x: 0, repeat: 50, yoyo: true }
          );
        }
      }

      // 閃光
      function light() {
        var lightTline = new TimelineMax({ ease: Power0.easeNone });

        lightTline
          .fromTo(
            el,
            0.05,
            { opacity: 1 },
            { opacity: 0.5, repeat: 10, yoyo: true },
            0.1
          )
          .fromTo(
            el,
            0.08,
            { opacity: 0.01 },
            { opacity: 0.2, repaet: 4, yoyo: true },
            "+=.5"
          )
          .fromTo(el, 0.5, { opacity: 0.1 }, { opacity: 0.8 });
      }

      //////////////// 冒號 Repaet ////////////////
      TweenMax.fromTo(
        botDomArr[2],
        1,
        { opacity: 1 },
        { opacity: 0, ease: Power0.easeNone, repeat: -1 },
        0.5
      );

      //////////////// 總時間軸Tline ////////////////
      var shakeTline = new TimelineMax({ ease: Power0.easeNone });

      shakeTline
        .fromTo(el, 0.05, { x: 1 }, { x: -0.05, repeat: 20, yoyo: true }, 1)
        .fromTo(
          el,
          0.1,
          { x: 0, y: -1 },
          { x: 0, y: 1.5, repeat: 6, yoyo: true }
        )
        .fromTo(
          el,
          0.07,
          { x: 0, y: -4 },
          { x: 0, y: 4, repeat: 2, yoyo: true }
        )
        .fromTo(
          el,
          0.04,
          { x: 0, y: 5 },
          { x: 0, y: -5, repeat: 2, yoyo: true }
        )
        .add(light)
        .add(bigerShake);
    }
  }
};
</script>

<style lang="scss" scoped>
.time-text-container {
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  .svg-wrapper {
    position: relative;
    .time-text-line-1, .time-text-line-2 {
      text-align: center;
      p, h1 {
        display: inline-block;
      }
      p {
        font-size: 22px !important;
        letter-spacing: 0.5rem;
        color: #b2aaaa;
        @media only screen and (min-width: 1280px) {
          font-size: 30px !important;
          letter-spacing: 0.8rem;
        }
      }
      h1 {
        font-family: digital;
        font-size: 114px !important;
        letter-spacing: 0.8rem;
        color: #ffffff;
        text-shadow: 0 0 17px #e8e8e8;
        @media only screen and (min-width: 1280px) {
          font-size: 186px !important;
        }
      }
    }
  }
}
</style>
